import { render, staticRenderFns } from "./ModalPanel.vue?vue&type=template&id=1ed79e7e&scoped=true"
import script from "./ModalPanel.vue?vue&type=script&lang=ts"
export * from "./ModalPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed79e7e",
  null
  
)

export default component.exports